import * as React from "react";
import AuthenticationPageNavigation from "components/authentication/AuthenticationPageNavigation";
import { PageHeader } from "components/common";
import useActiveBackend from "components/authentication/useActiveBackend";
import BackendActionLinks from "components/authentication/BackendActionLinks";
import DocsHelper from "util/DocsHelper";
import StringUtils from "util/StringUtils";
const _pageTitle = (authBackend) => {
  if (authBackend) {
    const backendTitle = StringUtils.truncateWithEllipses(authBackend.title, 30);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, "Edit Authentication Service - ", /* @__PURE__ */ React.createElement("i", null, backendTitle));
  }
  return "Create Active Directory Authentication Service";
};
const WizardPageHeader = ({ authenticationBackend: authBackend = void 0 }) => {
  const { finishedLoading, activeBackend } = useActiveBackend();
  const pageTitle = _pageTitle(authBackend);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AuthenticationPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: pageTitle,
      actions: /* @__PURE__ */ React.createElement(BackendActionLinks, { activeBackend, finishedLoading }),
      documentationLink: {
        title: "Authentication documentation",
        path: DocsHelper.PAGES.USERS_ROLES
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Configure authentication services of this cluster.")
  ));
};
export default WizardPageHeader;
